import {useEffect, useRef, useState} from 'react'
import { useNavigate, useLocation }  from 'react-router-dom'
import getSupabase                   from "../../util/supabase-utils"
import {DEBUG, logger}               from "../../util/log-utils"
import {Box, Link}                   from "@mui/material"
import BirdsyMiniMark                from "../BirdsyMiniMark"
import {Alert}                       from "@mui/lab"

const log = logger("AuthCallback", DEBUG)
const supabase = getSupabase()

const AuthCallback = () => {
	const navigate = useNavigate()
	const location = useLocation()
	const [error, setError] = useState(null)
	const hasProcessedRedirectRef = useRef(false)

	useEffect(() => {

		if (hasProcessedRedirectRef.current) return
		hasProcessedRedirectRef.current = true

		const processAuth = async () => {
			const { data: { session }, error: err } = await supabase.auth.getSession()

			if (err) {
				console.error('Error retrieving session:', err)
				setError(err)
			}
			else {
				if (!session) return
				const params = new URLSearchParams(location.search)
				const next = params.get('next') || '/prepkit'
				log.debug('Redirecting to:', next)
				navigate(next, { replace: true })
			}
		}

		processAuth()
	}, [navigate, location.search])

	const launchSupportEmail = () => {
		const currentUrl = window.location.href
		const body = `


------------------------------------------
Page: ${currentUrl}
Issue: ${error}
		`
		const mailtoLink = `mailto:support@birdsy.ai?subject=Birdsy%20Support&body=${encodeURIComponent(body)}`
		window.location.href = mailtoLink
	}

	return <Box p={5} textAlign={"center"}>
		<BirdsyMiniMark width={50}/>
		Processing authentication...

		{
			error &&
			<Alert severity="error" mb={2} mt={3}>Error signing in.
				Please <Link sx={{cursor: 'pointer'}} onClick={launchSupportEmail}>contact us</Link> and let us know.
			</Alert>
		}
	</Box>
}

export default AuthCallback
